import { Box } from '@mui/material'
import React from 'react'

const FieldSpacing = (props) => <Box my={4} {...props}/>

export default FieldSpacing
